import { Component, ElementRef, EventEmitter, forwardRef, Input, OnInit, Output } from "@angular/core";
import { ControlComponent } from "../../control.component";
import { ControlContact } from "../contact-control.model";
import { FormGroup, NG_VALIDATORS, NG_VALUE_ACCESSOR } from "@angular/forms";
import { ModalController } from "ionic-angular";
import { isDefined } from "ionic-angular/util/util";
import { TranslateService } from "@ngx-translate/core";
import { FormHelperService } from "../../../services/form-helper-service/form-helper.service";
import { ContactControlConfig } from "../contact-control-config.model";
import { VasAppFacade } from "../../../services/vas-app-facade.service";
import { ContactControlController } from "./contact-control.controller";
import { ContactControlModel } from "./contact-control.model";

@Component({
    selector: "contact",
    templateUrl: "./contact-control.component.html",
    providers: [
        {provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => ContactControlComponent), multi: true},
        {provide: NG_VALIDATORS, useExisting: forwardRef(() => ContactControlComponent), multi: true}
    ],
    viewProviders: [
        ContactControlController
    ]
})
export class ContactControlComponent extends ControlComponent implements OnInit {
    @Input() definition: ControlContact;
    @Output() changes: EventEmitter<any> = new EventEmitter();

    protected model: ContactControlModel;

    validateFn = () => {
        return this.contactFormGroup.valid;
    };

    constructor(
        protected appFacade: VasAppFacade,
        protected controller: ContactControlController,
        protected translateService: TranslateService,
        protected formHelperService: FormHelperService,
        protected modalCtrl: ModalController,
        protected elemRef: ElementRef
    ) {
        super(elemRef);
    }

    get isDisabledUpdateButton(): boolean {
        return !(isDefined(this.model) && isDefined(this.model.contact));
    }

    get contactFormGroup(): FormGroup {
        return isDefined(this.model) ? this.model.formGroup : undefined;
    }

    protected get contactId(): string {
        return isDefined(this.model) && isDefined(this.model.contact) ? this.model.contact.id : undefined;
    }

    ngOnInit(): void {

        super.ngOnInit();

        this.controller.model$
            .takeUntil(this.ngUnsubscribe)
            .subscribe(model => this.model = model);

        this.controller.model$.take(1)
            .subscribe(model =>
                model.formGroup.valueChanges
                    .subscribe(value => this.updateValue(this.dataToUpdate(value))));

        this.controller.onInit({ control: this.definition });
    }

    protected dataToUpdate(value: any): ContactControlConfig {
        return {
            contact: this.contactId,
            ...value
        } as ContactControlConfig;
    }

    writeValue(value: any): void {
        super.writeValue(value);

        this.controller.onWriteValue(value);
    }

    createContact(): void {
        this.controller.openContactForm(this.model);
    }

    updateContact(): void {
        this.controller.updateContactData(this.model);
    }

    showContactPicker(): void {
        this.controller.onShowContactPicker(this.model);
    }
}



// WEBPACK FOOTER //
// ./src/vas/controls/contact/form/contact-control.component.ts